/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomUser } from './CustomUser';
import {
    CustomUserFromJSON,
    CustomUserFromJSONTyped,
    CustomUserToJSON,
    CustomUserToJSONTyped,
} from './CustomUser';
import type { ProfileChoice } from './ProfileChoice';
import {
    ProfileChoiceFromJSON,
    ProfileChoiceFromJSONTyped,
    ProfileChoiceToJSON,
    ProfileChoiceToJSONTyped,
} from './ProfileChoice';

/**
 *
 * @export
 * @interface ProfileDetails
 */
export interface ProfileDetails {
    /**
     *
     * @type {CustomUser}
     * @memberof ProfileDetails
     */
    readonly user: CustomUser;
    /**
     *
     * @type {boolean}
     * @memberof ProfileDetails
     */
    readonly emailVerified: boolean;
    /**
     *
     * @type {string}
     * @memberof ProfileDetails
     */
    readonly pendingEmail: string | null;
    /**
     *
     * @type {Array<ProfileChoice>}
     * @memberof ProfileDetails
     */
    readonly languages: Array<ProfileChoice>;
    /**
     *
     * @type {Array<ProfileChoice>}
     * @memberof ProfileDetails
     */
    readonly timezones: Array<ProfileChoice>;
}

/**
 * Check if a given object implements the ProfileDetails interface.
 */
export function instanceOfProfileDetails(value: object): value is ProfileDetails {
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('emailVerified' in value) || value['emailVerified'] === undefined) return false;
    if (!('pendingEmail' in value) || value['pendingEmail'] === undefined) return false;
    if (!('languages' in value) || value['languages'] === undefined) return false;
    if (!('timezones' in value) || value['timezones'] === undefined) return false;
    return true;
}

export function ProfileDetailsFromJSON(json: any): ProfileDetails {
    return ProfileDetailsFromJSONTyped(json, false);
}

export function ProfileDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileDetails {
    if (json == null) {
        return json;
    }
    return {

        'user': CustomUserFromJSON(json['user']),
        'emailVerified': json['email_verified'],
        'pendingEmail': json['pending_email'],
        'languages': ((json['languages'] as Array<any>).map(ProfileChoiceFromJSON)),
        'timezones': ((json['timezones'] as Array<any>).map(ProfileChoiceFromJSON)),
    };
}

  export function ProfileDetailsToJSON(json: any): ProfileDetails {
      return ProfileDetailsToJSONTyped(json, false);
  }

  export function ProfileDetailsToJSONTyped(value?: Omit<ProfileDetails, 'user'|'email_verified'|'pending_email'|'languages'|'timezones'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

    };
}
